import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

export const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID;

// 이름 마스킹 (한글 기준: 2자 송* / 3자 송*인 / 4자 이상 첫·끝만 노출)
// isLoggedIn=true 면 실명 전체 노출
export const maskName = (name, isLoggedIn = false) => {
    if (!name) return "";
    const trimmed = String(name).trim();
    if (isLoggedIn) return trimmed;
    if (trimmed.length <= 1) return trimmed;
    if (trimmed.length === 2) return trimmed[0] + "*";
    return (
        trimmed[0] +
        "*".repeat(trimmed.length - 2) +
        trimmed[trimmed.length - 1]
    );
};

// 텍스트 복사
export const copyText = async (e, text) => {
    e.stopPropagation();
    try {
        if (navigator.clipboard) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (err) {
        console.error("복사 실패:", err);
        return false;
    }
};


// 닉네임 랜덤 지정
export const makeRandomNickname = () => {
    const adjectives = [
        "행복한",
        "즐거운",
        "신나는",
        "귀여운",
        "멋진",
        "똑똑한",
        "용감한",
        "반짝반짝한",
        "편안한",
        "배부른",
        "아름다운",
        "강한",
        "빠른",
        "졸린",
        "동글동글한",
        "작은",
        "밝은",
        "어두운",
        "따뜻한",
        "시원한",
        "달콤한",
        "매운",
        "부드러운",
        "쉬고있는",
    ];

    const seaCreatures = [
        "고래",
        "돌고래",
        "상어",
        "문어",
        "청어",
        "산호",
        "소라게",
        "킹크랩",
        "새우",
        "거북이",
        "가오리",
        "물개",
        "정어리",
        "해마",
        "말미잘",
        "바다뱀",
        "성게",
        "소라",
        "숭어",
        "홍합",
        "해파리",
    ];

    const randomAdjective =
        adjectives[Math.floor(Math.random() * adjectives.length)];
    const randomSeaCreature =
        seaCreatures[Math.floor(Math.random() * seaCreatures.length)];
    const randomNumber = Math.floor(Math.random() * 999) + 1;
    return `${randomAdjective}${randomSeaCreature}${randomNumber}`;
};


// 링크 내/외부 판단하여 열기
// @param {string} url - 이동할 URL
// @param {Function} navigate - react-router-dom의 navigate 함수
export const linkOpen = (url, navigate) => {
    if (!url) return;
    if (url.startsWith('http')) {
        window.open(url, '_blank', 'noopener,noreferrer');
    } else {
        navigate(url);
    }
}

export const formatTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMins < 1) return "방금 전";
    if (diffMins < 60) return `${diffMins}분 전`;
    if (diffHours < 24) return `${diffHours}시간 전`;
    if (diffDays < 7) return `${diffDays}일 전`;

    return date.toLocaleDateString("ko-KR", {
        month: "short",
        day: "numeric",
    });
};

const KST = "Asia/Seoul";

/**
 * 한국 시간(KST) 기준 D-Day 계산.
 * 자정(00:00 KST) 정렬 후 일 단위 차이로 truncate 이슈 회피.
 *
 * @param {string|Date|dayjs.Dayjs} date - 비교 대상 날짜 (KST 기준의 YYYY-MM-DD 등)
 * @returns {string|null} "D-day" | "D-N" | null (과거)
 */
export const getKstDday = (date) => {
    if (!date) return null;
    const target = dayjs.tz(date, KST).startOf("day");
    const today = dayjs().tz(KST).startOf("day");
    const diff = target.diff(today, "day");
    if (diff === 0) return "D-day";
    if (diff > 0) return `D-${diff}`;
    return null;
};
